<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog v-model="openDialog" max-width="400" persistent>
    <v-card class="pa-2" width="400">
      <v-card-title class="headline">
        {{ isEditMode ? $t('groupDialog.updateTitle') : $t('groupDialog.createTitle')}}
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-text-field
          class="ma-4"
          v-model="group.groupName"
          :label="$t('groupDialog.label')"
          :placeholder="$t('groupDialog.placeholder')"
          :rules="rules"
          hide-details="auto"
          ref="groupNameField"
        >
        </v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close">{{$t('groupDialog.cancelBtn')}}</v-btn>
          <v-btn :loading="isLoading" class="sms-primary-button" @click="upsertGroup" :disabled="!valid">
            {{ isEditMode ? $t('groupDialog.updateBtn') : $t('groupDialog.createBtn') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import ToastMixin from '@/mixins/ToastMixin';

export default {
  name: 'SmsGroupDialog',

  mixins: [ToastMixin],

  data() {
    return {
      openDialog: false,
      isLoading: false,
      rules: [
        value => !!value && !!value.trim() || this.$t('groupDialog.required'),
        value => this.validateGroupName(value) || this.$t('groupDialog.groupNameAlreadyExists')],
      group: () => {},
      valid: true
    };
  },

  computed: {
    ...mapGetters('groupsV2', ['getGroupByName']),

    isEditMode() {
      return !!this.group.id;
    }
  },

  created() {
    this.$root.$on('open-group-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-group-dialog');
  },

  methods: {
    ...mapActions('groupsV2', ['addUserGroup', 'editUserGroup']),

    open(group) {
      this.group = group ? cloneDeep(group) : {};
      this.openDialog = true;
      setTimeout(() => {
        this.$refs.groupNameField.focus();
      }, 250);
    },

    close() {
      this.group = {};
      this.openDialog = false;
      this.$refs.groupNameField.reset();
      this.$refs.form.reset();
    },

    upsertGroup() {
      this.isEditMode ? this.editGroup() : this.createGroup();
    },

    createGroup() {
      if (this.group.groupName && this.group.groupName.trim()) {
        if (this.getGroupByName(this.group.groupName)) {
          this.showError(this.$t('notifications.groupNameAlreadyExists', { name: this.group.groupName }));
        } else {
          this.addUserGroup(this.group)
            .then(() => {
              this.showSuccess(this.$t('notifications.createGroup', { name: this.group.groupName }));
              this.close();
            })
            .finally(() => (this.isLoading = false));
        }
      }
    },

    editGroup() {
      if (this.group.groupName.trim()) {
        if (this.getGroupByName(this.group.groupName)) {
          this.showError(this.$t('notifications.groupNameAlreadyExists', { name: this.group.groupName }));
        } else {
          this.isLoading = true;
          this.editUserGroup(this.group)
            .then(this.close)
            .finally(() => (this.isLoading = false));
        }
      }
    },

    validateGroupName(textName) {
      if (textName && this.getGroupByName(textName)) {
        this.showError(this.$t('notifications.groupNameAlreadyExists', { name: textName }));
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
